export default "__VITE_ASSET__e3f20e5f__"